import { Typography } from '@mui/material';
import ManageCMSTable from './ManageCMSTable';

const ManageCMS = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage CMS
      </Typography>
      <ManageCMSTable />
    </>
  );
};

export default ManageCMS;
